import { Auth } from 'aws-amplify';
import axios from 'axios';

const DIRECT_SND_API_BASE_URL = 'https://ih6wj7c88b.execute-api.us-west-1.amazonaws.com/dev';

export const sendDirectSndText = async ({ taskId, type }) => {
  const body = {
    taskId,
    attempt: 1,
    type,
  };
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return new Promise((resolve, reject) => {
    axios
      .post(`${DIRECT_SND_API_BASE_URL}/direct-snd/initiate-texting-task`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const sendDirectSndManualTextBatch = async ({
  orgId,
  userId,
  name,
  content,
  from,
  numbers,
  media_url,
  media_mime_type,
  media_file_name,
  media_size,
  manual_text_batch_id,
  type,
  send_at,
  task_billing_status_id,
  task_id,
}) => {
  const body = {
    orgId,
    userId,
    name,
    content,
    from,
    numbers,
    media_url,
    media_mime_type,
    media_file_name,
    media_size,
    attempt: 1,
    manual_text_batch_id,
    type,
    send_at,
    task_billing_status_id,
    task_id,
  };
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return new Promise((resolve, reject) => {
    axios
      .post(`${DIRECT_SND_API_BASE_URL}/direct-snd/initiate-manual-texting-task`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const sendDirectSndTestMessage = async ({ message, to, from, mediaUrl }) => {
  const body = {
    message,
    to,
    from,
    mediaUrl,
  };
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return new Promise((resolve, reject) => {
    axios
      .post(`${DIRECT_SND_API_BASE_URL}/direct-snd/test-text-handler`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
